import { handleActions } from 'redux-actions';
import * as documentsActions from '../actions/documents';

let documentsState = {
  allOrders: null,
  allOrdersStat: null,
  filterOrders: null,
  filterOrdersStat: null,
  documentsLoading: false,
  errorMessage: '',
};

export const documents = handleActions(
  {
    //  Get all Orders
    [documentsActions.getAllOrdersForDocuments]: state => {
      return { ...state, documentsLoading: true };
    },
    [documentsActions.getAllOrdersForDocumentsSuccess]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        documentTypes: payload.orderTypes,
        allOrders: payload.orders,
        allOrdersStat: payload.ordersStat,
        documentsLoading: false,
      };
    },
    [documentsActions.getAllOrdersForDocumentsFailure]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        errorMessage: payload,
        documentsLoading: false,
      };
    },
    //  Get Filter Orders
    [documentsActions.getFilterOrdersForDocuments]: state => {
      return { ...state, ordersLoading: true };
    },
    [documentsActions.getFilterOrdersForDocumentsSuccess]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        filterOrders: payload.orders,
        filterOrdersStat: payload.ordersStat,
        documentsLoading: false,
      };
    },
    [documentsActions.getFilterOrdersForDocumentsFailure]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        errorMessage: payload,
        documentsLoading: false,
      };
    },
  },
  documentsState
);
